'use client';

import Cookie from 'js-cookie';
import { signOut } from 'next-auth/react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { AlertaController, LayoutPrincipal, Rodape } from '@components';
import { Diario } from '@interfaces';
import { useDominiosStore } from '@stores/dominios.store';
import { useInformacoesStore } from '@stores/informacoes.store';
import * as Estilos from '@styles/index';
import { DiarioOficialView } from '@views/publico/diario-oficial';
import InformacoesImportantesView from '@views/publico/lazy-loading-informacoes-importantes/informacoes-importantes';

import StyledComponent from '../../../app/configuracao-styled-component';

interface PropriedadesTelaInicial {
  ultimasInformacoes: [];
  ultimosDiarios: Diario[];
  dominios: string[];
}

export const PaginaInicialView = ({
  ultimasInformacoes,
  ultimosDiarios,
  dominios,
}: PropriedadesTelaInicial) => {
  const rota = useRouter();
  const params = useSearchParams();

  const atribuirInformacoes = useInformacoesStore(({ atribuirInformacoes }) => atribuirInformacoes);
  const atribuirDominios = useDominiosStore(({ atribuirDominios }) => atribuirDominios);

  useEffect(() => {
    atribuirInformacoes(ultimasInformacoes);
  }, [ultimasInformacoes, atribuirInformacoes]);

  useEffect(() => {
    atribuirDominios(dominios);
  }, [dominios, atribuirDominios]);

  useEffect(() => {
    const authFail = params?.get('auth-fail');

    if (authFail) {
      rota.replace('/');
      signOut({ redirect: false }).then();
      AlertaController.disparar({
        titulo: 'Atenção',
        tipo: 'suporte',
        mensagem: authFail,
        textoConfirmar: 'Ok',
        fechar: false,
      });
    }

    if (sessionStorage.getItem('sessao')) {
      AlertaController.disparar({
        titulo: 'Sessão expirada!',
        tipo: 'suporte',
        mensagem: 'Por favor, realize o login novamente.',
        textoConfirmar: 'Ok',
        fechar: false,
      });

      sessionStorage.removeItem('sessao');
    }

    if (Cookie.get('autenticacao-erro')) {
      AlertaController.disparar({
        titulo: 'Oops!',
        mensagem: `Ocorreu uma falha durante a tentativa de autenticação, por favor tente novamente!\nErro: ${Cookie.get(
          'autenticacao-erro',
        )}`,
        textoConfirmar: 'Ok',
        tipo: 'suporte',
        fechar: false,
      });

      Cookie.remove('autenticacao-erro');
    }

    if (Cookie.get('gestor-sem-permissao')) {
      AlertaController.disparar({
        titulo: 'Usuário sem permissão',
        mensagemComHtml: `
          <p>Identificamos uma sessão ativa com um CPF diferente do gestor responsável pela assinatura. Para garantir a integridade da operação, a sessão foi <strong>encerrada</strong>.</p>
          <br />
          <p>Pedimos que o gestor acesse novamente o link do e-mail e faça login com o próprio CPF para concluir a assinatura.</p>
        `,
        textoConfirmar: 'Ok',
        tipo: 'erro',
        fechar: false,
      });

      Cookie.remove('gestor-sem-permissao');
    }
  }, []);

  return (
    <StyledComponent>
      <LayoutPrincipal>
        <DiarioOficialView diarios={ultimosDiarios} />
        <Estilos.InformacoesImportantes>
          <InformacoesImportantesView dispositivo='desktop' informacoes={ultimasInformacoes} />
        </Estilos.InformacoesImportantes>
      </LayoutPrincipal>
      <Rodape />
    </StyledComponent>
  );
};
